<div style="background: #F5F6FA">
  <div class="row">
    <div class="col-md-12">
      <!-- breadcrumb -->
      <div class="page-breadcrumb">
        <ul class="page-breadcrumb__trail">
          <li>Dashboard</li>
        </ul>
      </div>
      <!-- breadcrumb End -->
      <!--Landing page-->
      <div class="panel panel-default">
        <p><img src="../../assets/img/hatch-db.jpg" height="652" width="1283" alt="dashboard image"/></p>
      </div>
    </div>
  </div>
</div>
